import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import CompanyLayout from "layouts/company";
import SubscriptionPlans from "views/subscription/SubscriptionPlans";
const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
       <Route path="company/*" element={<CompanyLayout />} />
      <Route path="subscription/plans" element={<SubscriptionPlans />} />

      <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />

      {/* Fallback for undefined routes, redirect to login */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;
